import React from "react";
import { Tab, Tabs } from "@bloomberg/media-ui-core";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import { PlusThinStroke } from "@bloomberg/media-ui-icons";
import styles from "./styles.module.css";
import {
  usePortfolios,
  useSelectedPortfolioId,
  useWatchlistActions,
} from "~context/WatchlistContext";
import { NEW_PORTFOLIO_TAB_TITLE } from "~constants/Portfolio";

/**
 * Watchlist Tabs Component (Delta)
 *
 * Uses WatchlistContext (Zustand + Octagon client)
 */
export default function WatchlistTabs() {
  const portfolios = usePortfolios();
  const selectedPortfolioId = useSelectedPortfolioId();
  const actions = useWatchlistActions();

  const handleTabSwitch = (tabTitle: string, tabIndexClicked?: number) => {
    // Track tab click events
    trackClickEvent(tabTitle.toLocaleLowerCase().replaceAll(/\s/g, "_"));
    trackClickEvent("watchlistTabSwitch", "tab_switch", "click", "watchlist");

    if (tabTitle === NEW_PORTFOLIO_TAB_TITLE) {
      // TODO: Handle new portfolio creation
      // For now, just track the click
      trackClickEvent("watchlistNew", "create_new", "click", "watchlist");

      return;
    }

    // Find the portfolio that was clicked
    if (tabIndexClicked === undefined) {
      return;
    }

    const portfolio = portfolios[tabIndexClicked];

    if (!portfolio) {
      return;
    }

    // Switch to the selected portfolio
    void actions.selectPortfolio(portfolio.id);
  };

  // Don't render tabs if no portfolios (initial load or error)
  // Keep tabs visible during tab switches (when isLoading but portfolios exist)
  if (portfolios.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.navigationWrapper}>
        <Tabs
          className={styles.tabbedView}
          onTabSwitch={handleTabSwitch}
          showSlider
          variant="default"
        >
          {[
            // Render portfolio tabs
            ...portfolios.map((portfolio) => (
              <Tab
                title={portfolio.name}
                key={portfolio.id}
                isActive={selectedPortfolioId === portfolio.id}
                isDefault={
                  selectedPortfolioId === portfolio.id || portfolio.isDefault
                }
                className={styles.tabContent}
              >
                &nbsp;
              </Tab>
            )),
            // Render "+" tab for creating new portfolio
            <Tab
              title={NEW_PORTFOLIO_TAB_TITLE}
              key={NEW_PORTFOLIO_TAB_TITLE}
              isDefault={false}
              className={styles.tabContent}
              Icon={<PlusThinStroke />}
            >
              &nbsp;
            </Tab>,
          ]}
        </Tabs>
      </div>
    </div>
  );
}
